import React from "react";
import { Link, NavLink } from "react-router-dom";

import AccountMenu from "../auth/AccountMenu.jsx";
import { useSession } from "../context/SessionContext.jsx";
import { useUser } from "../hooks/useUsers";
import { COPY } from "../i18n/storefrontCopy";
import { useStorefrontLocale } from "../i18n/StorefrontLocale";
import logo from "../assets/winvest-logo.svg";
import LanguageToggle from "./LanguageToggle";
import "./Header.css";

const Header = () => {
  const { currentUid } = useSession();
  const { user } = useUser(currentUid);
  // "en" everywhere except the storefront, where it follows the visitor's choice.
  const { lang, onPortfolioStorefront, onStorefront } = useStorefrontLocale();
  if (onPortfolioStorefront) return null;

  const t = COPY[lang].nav;

  const navClass = ({ isActive }) => (
    `header__link${isActive ? " header__link--active" : ""}`
  );

  return (
    <header className="header" lang={onStorefront ? COPY[lang].htmlLang : undefined}>
      <div className="header__inner">
        <Link to="/" className="header__logo" aria-label="WInvest home">
          <img src={logo} alt="" className="header__logo-img" width="120" height="28" />
        </Link>
        <nav aria-label="Main" className="header__nav">
          <NavLink to="/" end className={navClass}>{t.home}</NavLink>
          {user && (
            <NavLink to={`/profile/${currentUid}`} className={navClass}>
              {t.myProfile}
            </NavLink>
          )}
        </nav>
        <div className="header__spacer" />
        {onStorefront && <LanguageToggle />}
        <AccountMenu profile={user} labels={t} />
      </div>
    </header>
  );
};

export default Header;
